import { h } from "preact";
import { isColor } from "../helpers/colors";

const findSwatch = (product, name) => {
  const colorOptionValues = product.options.find((option) =>
    isColor(option.name),
  )?.optionValues;

  return colorOptionValues.find((optionValue) => optionValue.name === name)
    ?.swatch;
};

export default function SwatchImage({
  product,
  optionValue,
  handle,
  className = "",
}) {
  if (!product || !optionValue || !handle) return null;

  const swatch = findSwatch(product, optionValue);

  if (swatch) {
    if (swatch.image) {
      return (
        <img
          className={className}
          src={getSizedImageUrl(swatch.image.previewImage.url, "40x")}
          alt={swatch.image.alt}
          aria-hidden="true"
        />
      );
    } else {
      return (
        <div className={className} style={{ background: swatch.color }}></div>
      );
    }
  }

  return (
    <img
      className={className}
      src={`${window.cdn.fileUrl}/${handle}-${optionValue
        .split(" / ")
        .pop()
        .toLowerCase()
        .replace(/[^\w\s]/gi, "")
        .replace(/\s/g, "-")}_40x.png`}
      alt={optionValue.split(" / ").pop()}
      aria-hidden="true"
    />
  );
}
